export const isEqual = (id1: string, id2: string) => Number(id1) === Number(id2)
